function fmtMoeda(v) {
  return (Number(v) || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
}
function fmtNum(v) {
  return (Number(v) || 0).toLocaleString('pt-BR');
}
function fmtDataCurta(d) {
  return d ? new Date(d + 'T00:00').toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit' }) : '';
}

const STATUS_REUNIAO = {
  'Realizado': { cor: '#16a34a', bg: '#dcfce7' },
  'Agendado':  { cor: '#b45309', bg: '#fef3c7' },
  'No-show':   { cor: '#dc2626', bg: '#fee2e2' },
  'Cancelado': { cor: 'var(--gray-400)', bg: 'var(--bg-secondary)' },
};

function Card({ label, valor, cor, sub }) {
  return (
    <div className="card" style={{ padding: '14px 16px' }}>
      <div style={{ fontSize: 10.5, fontWeight: 700, color: 'var(--text-secondary)', textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: 6 }}>{label}</div>
      <div style={{ fontSize: 22, fontWeight: 800, color: cor || 'var(--purple)', fontFamily: 'Playfair Display, serif' }}>{valor}</div>
      {sub && <div style={{ fontSize: 11, color: 'var(--text-secondary)', marginTop: 2 }}>{sub}</div>}
    </div>
  );
}

function BarChartMini({ dados, campo, cor, label, fmt }) {
  if (!dados.length) return null;
  const max = Math.max(...dados.map(d => d[campo] || 0), 1);
  return (
    <div>
      <div style={{ fontSize: 11, fontWeight: 700, color: 'var(--text-secondary)', marginBottom: 12, textTransform: 'uppercase', letterSpacing: '0.05em' }}>{label}</div>
      <div style={{ display: 'flex', gap: 3, alignItems: 'flex-end', height: 90, overflowX: 'auto' }}>
        {dados.map((d, i) => {
          const h = ((d[campo] || 0) / max) * 80;
          return (
            <div key={i} style={{ minWidth: 22, flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
              <div style={{ fontSize: 8, fontWeight: 700, color: cor }}>{fmt ? fmt(d[campo]) : (d[campo] || 0)}</div>
              <div style={{ width: '100%', background: 'var(--bg-secondary)', borderRadius: '4px 4px 0 0', height: 80, display: 'flex', alignItems: 'flex-end' }}>
                <div style={{ width: '100%', height: `${h}px`, background: `linear-gradient(180deg,${cor},${cor}88)`, borderRadius: '4px 4px 0 0', transition: 'height .3s' }} />
              </div>
              <div style={{ fontSize: 7.5, color: 'var(--gray-400)' }}>{fmtDataCurta(d.data)}</div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default function RelatorioView({ dados }) {
  if (!dados) return null;
  const { totais, leads, reunioes, financeiro, serie_diaria } = dados;
  const taxaQualificacao = leads.total ? Math.round((leads.qualificados / leads.total) * 100) : 0;
  const taxaConversao = reunioes.realizadas ? Math.round((financeiro.contratos_fechados / reunioes.realizadas) * 100) : 0;

  return (
    <div>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))', gap: 12, marginBottom: 20 }}>
        <Card label="Faturamento recebido" valor={fmtMoeda(financeiro.faturamento_recebido)} cor="#16a34a" />
        <Card label="Contratos fechados" valor={fmtNum(financeiro.contratos_fechados)} />
        <Card label="Total de leads" valor={fmtNum(leads.total)} />
        <Card label="Leads qualificados" valor={fmtNum(leads.qualificados)} sub={`${taxaQualificacao}% de qualificação`} />
        <Card label="Reuniões realizadas" valor={`${fmtNum(reunioes.realizadas)} / ${fmtNum(reunioes.agendadas)}`} sub="realizadas / agendadas" />
        <Card label="Taxa de conversão" valor={`${taxaConversao}%`} cor="#7B2FBE" />
      </div>

      {leads.por_origem?.length > 0 && (
        <div className="card" style={{ padding: 16, marginBottom: 20 }}>
          <div style={{ fontSize: 11, fontWeight: 700, color: 'var(--text-secondary)', marginBottom: 10, textTransform: 'uppercase' }}>Leads por origem</div>
          <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap' }}>
            {leads.por_origem.map(o => (
              <span key={o.origem} style={{ background: 'var(--bg-secondary)', color: 'var(--purple-rich)', padding: '5px 12px', borderRadius: 20, fontSize: 12, fontWeight: 600 }}>
                {o.origem}: {o.total}
              </span>
            ))}
          </div>
        </div>
      )}

      {(totais.impressoes > 0 || totais.cliques > 0 || totais.valor_gasto > 0) && (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))', gap: 12, marginBottom: 20 }}>
          <Card label="Impressões" valor={fmtNum(totais.impressoes)} cor="#4A90D9" />
          <Card label="Cliques" valor={fmtNum(totais.cliques)} cor="#4A90D9" />
          <Card label="Valor investido" valor={fmtMoeda(totais.valor_gasto)} cor="#4A90D9" />
        </div>
      )}

      {(totais.seguidores_atual || totais.curtidas > 0 || totais.videos_postados > 0) && (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(140px, 1fr))', gap: 12, marginBottom: 20 }}>
          {totais.seguidores_atual != null && <Card label="Seguidores" valor={fmtNum(totais.seguidores_atual)} cor="#D4789B" sub={totais.novos_seguidores ? `+${totais.novos_seguidores} no período` : null} />}
          <Card label="Vídeos postados" valor={fmtNum(totais.videos_postados)} cor="#D4789B" />
          <Card label="Curtidas" valor={fmtNum(totais.curtidas)} cor="#D4789B" />
          <Card label="Comentários" valor={fmtNum(totais.comentarios)} cor="#D4789B" />
          <Card label="Visualizações" valor={fmtNum(totais.visualizacoes)} cor="#D4789B" />
        </div>
      )}

      {serie_diaria?.length > 1 && (
        <div className="card" style={{ padding: 18, marginBottom: 20 }}>
          <BarChartMini dados={serie_diaria} campo="valor_gasto" cor="#4A90D9" label="Investimento em tráfego por dia" fmt={fmtMoeda} />
        </div>
      )}

      {reunioes.lista?.length > 0 && (
        <div className="card" style={{ padding: 16 }}>
          <div style={{ fontSize: 11, fontWeight: 700, color: 'var(--text-secondary)', marginBottom: 10, textTransform: 'uppercase' }}>Reuniões do período</div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
            {reunioes.lista.map((r, i) => {
              const st = STATUS_REUNIAO[r.status] || STATUS_REUNIAO['Agendado'];
              return (
                <div key={i} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '8px 10px', background: 'var(--bg-secondary)', borderRadius: 8 }}>
                  <div>
                    <div style={{ fontSize: 12.5, fontWeight: 600, color: 'var(--text-primary)' }}>{r.titulo}</div>
                    <div style={{ fontSize: 11, color: 'var(--text-secondary)' }}>{fmtDataCurta(r.data)}{r.hora ? ` às ${r.hora.slice(0,5)}` : ''}</div>
                  </div>
                  <span style={{ background: st.bg, color: st.cor, fontSize: 10.5, fontWeight: 700, padding: '3px 10px', borderRadius: 20 }}>{r.status || 'Agendado'}</span>
                </div>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
}
